import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MapService} from '../../../../commons/map.service';
import {FileManagementService} from '../../../../service/file-manager.service';
import {AppService} from '../../../../commons/app.service';
import {FourDService} from '4d-mapper';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AppBaseComponent} from '../../../../commons/AppBaseComponent';
import { XsApplicationEventsService } from '../../../../xs/services/events/application-events.service';

@Component({
  selector: 'app-terms-condition-dialog',
  templateUrl: './terms-condition-dialog.component.html',
  styleUrls: ['./terms-condition-dialog.component.scss']
})
export class TermsConditionDialogComponent extends AppBaseComponent implements OnInit, OnDestroy {
  estimatedPrice: number = -1;

  constructor(private fourD: FourDService, public service: AppService, private r: Router, sn: MatSnackBar, d: MatDialog, private ar: ActivatedRoute, private t: TranslateService, private trans: TranslateService
    , private fb: FormBuilder, private cd: ChangeDetectorRef, private fileManager: FileManagementService, public dialogRef: MatDialogRef<TermsConditionDialogComponent>, public snackBar: MatSnackBar,
              public mapService: MapService, @Inject(MAT_DIALOG_DATA) public data, private httpClient: HttpClient, applicationEvents:XsApplicationEventsService) {
    super(service, r, sn, d, applicationEvents);
  }

  init() {
    this.calculatePrice();
  }

  agree() {
    this.dialogRef.close({currentJob: this.data.currentJob})
  }

  calculatePrice() {
    this.estimatedPrice = -1;
    let tt = this.data.currentJob.jobType.baseTransform;
    this.data.currentJob.quoteTransform(tt).subscribe(amount => {
      this.estimatedPrice = amount.amount;
    });
  }
  
}
